import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { createRouteRef } from '@backstage/core-plugin-api';
import BuildIcon from '@material-ui/icons/Build';

const rootRouteRef = createRouteRef({
  id: 'qa-automated-tests',
});

const allureReportRouteRef = createRouteRef({
  id: 'qa-automated-tests-reports',
});

const s3ReportsRouteRef = createRouteRef({
  id: 'qa-automated-tests-s3-reports',
});

export default createFrontendPlugin({
  pluginId: 'qa-automated-tests',
  extensions: [
    // Main QA Automated Tests page
    PageBlueprint.make({
      name: 'main',
      params: {
        path: '/qa-automated-tests',
        title: 'Automated Tests',
        icon: <BuildIcon />,
        routeRef: rootRouteRef,
        loader: async () => {
          const module = await import('./components/QaAutomatedTestsPage');
          return import('react').then(React => React.createElement(module.QaAutomatedTestsPage));
        },
      },
    }),
    
    // Allure Report page (sub-page without nav item)
    PageBlueprint.make({
      name: 'allure-report',
      params: {
        path: '/qa-automated-tests/reports',
        routeRef: allureReportRouteRef,
        loader: async () => {
          const module = await import('./components/AllureReportPage');
          return import('react').then(React => React.createElement(module.AllureReportPage));
        },
      },
    }),

    // S3 Reports browser page (sub-page without nav item)
    PageBlueprint.make({
      name: 's3-reports',
      params: {
        path: '/qa-automated-tests/s3-reports',
        routeRef: s3ReportsRouteRef,
        loader: async () => {
          const module = await import('./components/S3ReportsPage');
          return import('react').then(React => React.createElement(module.S3ReportsPage));
        },
      },
    }),
  ],
});

export { rootRouteRef, allureReportRouteRef, s3ReportsRouteRef };
